<template>
	<FormSearchableInput2
		ref="searchable"
		:selected="selected"
		:list="searchList"
		:is-search-loading="isLoading"
		v-bind="$attrs"
		:search="handleSearch"
		@update:text="$emit('update:text', $event)"
		@update:selected="$emit('update:selected', $event)"
	/>
</template>
<script>
import Providers from "@/API/Providers.js"
import LoadingMixins from "@/mixins/loading.js"
import FormSearchableInput2 from "@/components/FormSearchableInput2.vue"

export default {
	name: "SelectProvider",
	mixins: [LoadingMixins],
	model: {
		prop: 'selected',
		event: 'update:selected'
	},
	props: {
		selected: [Object, Number, String],
		disabled: Boolean,
		onlyFulfillment: Boolean,
		onlyFreightForwarder: Boolean,
		onlyCargoAgent: Boolean,
		onlyFreight: Boolean,
		onlyFirstMile: Boolean,
		onlyLastMile: Boolean,
		onlyAirCompany: Boolean,
		withConfig: Boolean,
		partner: Object
	},
	components: {
		FormSearchableInput2
	},
	data() {
		return {
			searchList: []
		}
	},
	methods: {
		/**
		 * handle Search
		 * @param search
		 */
		async handleSearch(search) {

			const data = {
				search,
				partner_id: this.partner?.id
			}

			if (this.partner) {
				data.partner_id = this.partner.id
			}

			if (this.onlyFulfillment) {
				data["only-fulfillment"] = true
			}

			if (this.onlyLastMile) {
				data["only-lastmile"] = true
			}

			if (this.onlyCargoAgent) {
				data["only-cargo-agent"] = true
			}

			if (this.onlyFreight) {
				data["only-freight"] = true
			}

			if (this.onlyFreightForwarder) {
				data["only-freight-forwarder"] = true
			}

			if(this.withConfig) {
				data['with-general-config'] = true
			}

			const [err, res] = await Providers.getSelect(data)

			if (err) {
				// TODO...
				return []
			}

			return res.data.data
		},
		/**
		 * Export focus
		 */
		focus() {
			this.$refs.searchable.focus()
		},
		/**
		 * Export clear
		 */
		clear() {
			this.$refs.searchable.clear()
		}
	}
}
</script>